/**
 * Returns the active merchantId.
 * Impersonation tabs store it in sessionStorage (tab-isolated).
 * Normal sessions store it in localStorage.
 */
export const getMerchantId = () =>
  sessionStorage.getItem("merchantId") || localStorage.getItem("merchantId");

/**
 * Returns the active merchantToken.
 * Impersonation tabs store it in sessionStorage (tab-isolated).
 * Normal sessions store it in localStorage.
 */
export const getMerchantToken = () =>
  sessionStorage.getItem("merchantToken") ||
  localStorage.getItem("merchantToken");
